var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('h3',{staticClass:"page-title"},[_vm._v("Tenants Management")]),_c('v-row',[_c('v-col',[_c('tenant-list',{attrs:{"userRole":_vm.userRole}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }